import { RouterView } from "vue-router";
import { rosterRouter } from "./roster/roster.router"
import { onboardingRouter } from './onboarding/onboarding.router'
import { positiveRouter } from './positive/positive.router'
import { resignManageRouter } from './resign-manage/resign-manage.router'
import { personnelTransferRouter } from './personnel-transfer/personnel-transfer.router'
import { laborContractRouter } from './labor-contract/labor-contract.router'

export const staffManageRouter = {
  path: "/staff-manage",
  name: "staff-manage",
  redirect: "/staff-manage/staff-roster/list",
  component: RouterView,
  meta: { title: "员工管理", icon: "member" },
  children: [
    ...rosterRouter,
    ...onboardingRouter,
    ...positiveRouter,
    ...resignManageRouter,
    ...personnelTransferRouter,
    ...laborContractRouter
  ],
};
